export default {
  EXCORIATION: 'excoriation', // ผิวแห้ง
  OILY_SKIN: 'oily skin', // ผิวมัน
  HAIR_LOSE: 'hair lose', // ขนร่วง
  RASH: 'rash', // ผื่น
  TICK: 'tick' // เห็บ
}
